import { connect } from 'react-redux';

import { getKnmPmTypeFormValueIsAnnouncementOfWarning } from 'KnmPmPackage/MainModule/selectors/knmPmSelectors';
import { IKnmPmFormReason } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormReason';

import { Section } from '../../../UIPackage/FormModule/components/Section';
import { PmApproveDocs } from './PmApproveDocs';
import { PmRequirements } from './PmRequirements';
import { IDictionaryKnoOrganizationSelectOption } from '../../../CorePackage/DictionariesModule/interfaces/IDictionaryKnoOrganizationSelectOption';
import { IKnmStatus } from '../../../APIPackage/CatalogsModule/interfaces/IKnmStatus';
import { IDictionarySupervisionTypeSelectOption } from '../../../CorePackage/DictionariesModule/interfaces/IDictionarySupervisionTypeSelectOption';
import { PM_EVENT_SUBJECT } from '../../../CorePackage/MainModule/routes/routes';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import {
  getUserRoleIsProsecutorOrSuperProsecutor,
  getUserRoleIsSupervisor,
} from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { getKnmIsNew } from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { KnmErknmStatusCodesEnum } from '../../../APIPackage/CatalogsModule/enums/KnmErknmStatusCodesEnum';
import { PmTakenMeasures } from './PmTakenMeasures';
import { IKnmErknmFormObject } from '../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormObject';
import { IKnmFormRiskIndicators } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRiskIndicators';

interface IPmEventSubjectProps {
  className?: string;
  watchOnly: boolean;
  knoOrganization?: IDictionaryKnoOrganizationSelectOption;
  supervisionType?: IDictionarySupervisionTypeSelectOption;
  objectsPm?: IKnmErknmFormObject[];
  riskIndicators?: IKnmFormRiskIndicators[];
  statusCode?: IKnmStatus['code'];
  isOP: boolean;
  isLinkedByImpossibility?: boolean;
  reasonFieldValue?: IKnmPmFormReason | undefined;
}

interface IPmEventSubjectStoreProps {
  isSupervisor: boolean;
  isNewKnm: boolean;
  isProsecutorOrSuperProsecutor: boolean;
  isAnnouncementOfWarning: boolean;
}

const PmEventSubjectWithoutStore = ({
  className,
  watchOnly,
  knoOrganization,
  supervisionType,
  objectsPm,
  riskIndicators,
  statusCode,
  isSupervisor,
  isProsecutorOrSuperProsecutor,
  isNewKnm,
  isOP,
  isAnnouncementOfWarning,
  isLinkedByImpossibility,
  reasonFieldValue,
}: IPmEventSubjectProps & IPmEventSubjectStoreProps) => {
  const isDisabledByStatus = !isNewKnm && statusCode !== KnmErknmStatusCodesEnum.FILL_IN_PROCESS;
  const isRequirementsWatchOnly: boolean = watchOnly || isProsecutorOrSuperProsecutor || isDisabledByStatus;
  const isApproveDocsWatchOnly: boolean = watchOnly || !isSupervisor || isDisabledByStatus;

  return (
    <div className={className}>
      <Section title="Сведения о предмете профилактического мероприятия" id={PM_EVENT_SUBJECT}>
        <PmRequirements
          watchOnly={isRequirementsWatchOnly}
          knoOrganization={knoOrganization}
          supervisionType={supervisionType}
          isLinkedByImpossibility={isLinkedByImpossibility}
          objectsPm={objectsPm}
          riskIndicators={riskIndicators}
          reasonFieldValue={reasonFieldValue}
        />
        {isAnnouncementOfWarning && isOP && (
          <PmTakenMeasures watchOnly={!isNewKnm && statusCode !== KnmErknmStatusCodesEnum.FILL_IN_PROCESS} />
        )}
        <PmApproveDocs watchOnly={isApproveDocsWatchOnly} supervisionType={supervisionType} />
      </Section>
    </div>
  );
};

const mapStateToProps = (state: IRootState): IPmEventSubjectStoreProps => ({
  isNewKnm: getKnmIsNew(state) || false,
  isProsecutorOrSuperProsecutor: getUserRoleIsProsecutorOrSuperProsecutor(state),
  isSupervisor: getUserRoleIsSupervisor(state),
  isAnnouncementOfWarning: getKnmPmTypeFormValueIsAnnouncementOfWarning(state),
});

export const PmEventSubject = connect(mapStateToProps)(PmEventSubjectWithoutStore);
